import { Button, Menu, MenuItem, Tooltip } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import LanguageIcon from '@material-ui/icons/Language'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

function LanguageDropdownButton({ noMargin }: { noMargin?: boolean }) {
	const { i18n } = useTranslation()
	const { t: tLanguages } = useTranslation('languages')
	const [language, setLanguage] = useState<string | null>(null)
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
	const location = useLocation()

	useEffect(() => {
		setLanguage(i18n.language)
	}, [i18n.language])

	const handleLanguageClick = (language: string) => {
		i18n.changeLanguage(language)
		console.log('location: ', location)

		// Breadcrumbs component reads i18n directly and refetches via RTK Query.

		handleClose()
	}

	const handleMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	return (
		<div style={{ marginRight: '5px' }}>
			<Tooltip
				title={
					(language === 'en' && tLanguages('english')) ||
					(language === 'fr' && tLanguages('french'))
				}
			>
				<Button
					aria-label="switch language"
					aria-controls="menu-appbar"
					aria-haspopup="true"
					color="primary"
					size="small"
					onClick={(e) => handleMenu(e)}
					style={{ marginTop: noMargin ? 0 : '1rem', paddingLeft: 0 }}
				>
					<LanguageIcon />
				</Button>
			</Tooltip>
			<Menu
				id="menu-appbar"
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				style={{ zIndex: 60000 }}
			>
				<MenuItem onClick={() => handleLanguageClick('en')}>
					{tLanguages('english', 'English')}
					{language === 'en' && (
						<CheckIcon style={{ marginLeft: '5px' }} />
					)}
				</MenuItem>
				<MenuItem onClick={() => handleLanguageClick('fr')}>
					{tLanguages('french', 'French')}
					{language === 'fr' && (
						<CheckIcon style={{ marginLeft: '5px' }} />
					)}
				</MenuItem>
			</Menu>
		</div>
	)
}

export default LanguageDropdownButton
